module.exports = __webpack_public_path__ + "img/disclaimer-zhCn.94aa3e24.png";